module.exports = __webpack_public_path__ + "img/icon_building_5.bf835fb7.png";